import { jsx as m } from "react/jsx-runtime";
import n from "classnames";
import t from "./index.es567.js";
import { useTheme as f } from "./index.es173.js";
const C = "color-indicator-component", y = ({
  entityColor: o = 1,
  thickness: i = "regular",
  disabled: s,
  color: e,
  testId: l = C,
  variant: a = "default"
}) => {
  const d = f().activeTheme.theme.POI[o][a];
  let r = t[`entityColor${o}`];
  !e && o && (a === "light" ? r = t[`entityColor${o}Light`] : a === "dark" && (r = t[`entityColor${o}Dark`]));
  const c = n(
    t.container,
    t[`thickness-${i}`],
    r,
    {
      [t.disabled]: s
    }
  );
  return /* @__PURE__ */ m(
    "div",
    {
      className: c,
      "data-testid": l,
      style: { backgroundColor: e },
      "data-type": "color-indicator",
      "data-variant": a,
      "data-thickness": i,
      "data-colored": e || d,
      "aria-disabled": s,
      "aria-label": `Color indicator ${a} variant`,
      role: "status"
    }
  );
};
export {
  C as COLOR_INDICATOR_DEFAULT_TESTID,
  y as ColorIndicator
};
//# sourceMappingURL=index.es26.js.map
